import { toastController, loadingController } from '@ionic/core';
import moment from 'moment';
import { useCallback, useContext, useEffect, useState } from 'react';
import { ConfigContext } from '../../../contexts/ConfigContext';
import db from '../../../resources/db';
import { getBalanceCreditDebit } from '../../../resources/Hooks';
import PaymentReceiptPattern from '../../Invoice/PaymentReceiptPattern';
import ledgerPattern from '../LedgerPattern';


export function useCustomerDetails(customerId) {
    const { Company, Ledger, setLedger } = useContext(ConfigContext); // let use Ledger Context is with useContext , useState is having bug
    const [CustomerDetail, setCustomerDetail] = useState({});
    const [amt, setAmt] = useState(0);
    const [date, setDate] = useState(Date());
    const [alert, setAlert] = useState(false);
    const [editable, seteditable] = useState(true);

    const getCustomerData = useCallback(async () => {
        let result = await db.ledger.get({ "customerName": customerId })
        if (result) {
            sessionStorage.setItem('currentParty', customerId);
            setCustomerDetail(result)
            if (CustomerDetail.id) { 
                await db.ledger.where("customerName").equals(CustomerDetail.customerName).toArray().then(res => {
                    setLedger(res.map((item) => {
                        item.date = new Date(item.date)
                        return item
                    }));
                });
                if (!(CustomerDetail.editable === null || CustomerDetail.editable === undefined)) {
                    seteditable(CustomerDetail.editable);
                } else {
                    seteditable(true);
                }
                loadingController.dismiss('true', undefined, "ledgerLoad").then(res => {
                    console.log('loading done', res);
                });
            }
        } else {
            setAlert(true)
        }
    }, [CustomerDetail.customerName, CustomerDetail.editable, CustomerDetail.id, customerId, setLedger])

    useEffect(() => {
        getCustomerData();
    }, [getCustomerData])



    let { balance, credit, debit } = getBalanceCreditDebit(Ledger);

    /** Remove Data from Ledger by Id */
    const removeFromLedger = id => {
        db.ledger.delete(id).then(res => {
            console.log("Ledger Data Removed", res);
            toastController.create({
                color: 'danger',
                duration: 2000,
                message: `Ledger Data Removed`,
                showCloseButton: true
            }).then(toast => {
                toast.present();
            });
        });

        db.ledger
            .where("customerName")
            .equals(CustomerDetail.customerName)
            .toArray()
            .then(res => {
                setLedger(res.map((item) => {
                    item.date = new Date(item.date)
                    return item
                }));
            });
    };

    const deleteCustomer = () => {
        db.ledger.where("customerName").equals(CustomerDetail.customerName).delete().then((res) => {
            console.log("Deleted Customer, " + res);
        })
    }

    /** Add Data from Ledger */
    const addToLedger = e => {
        e.preventDefault();
        // let amt = document.getElementById("amt").value;
        let type = document.getElementById("type").value;
        if (!type) {
            type = 'credit'
        }
        // console.log(type);
        // let date = document.getElementById("date").value;
        let setDate;
        if (date) {
            setDate = moment(date).format("ll");
        } else {
            setDate = moment().format("ll");
        }

        // console.log(setDate);
        let data;
        if (type === "credit") {
            data = {
                customerName: CustomerDetail.customerName,
                customerDetails: CustomerDetail.customerDetails ? CustomerDetail.customerDetails : "",
                customerContact: CustomerDetail.customerContact ? CustomerDetail.customerContact : "",
                customerGST: CustomerDetail.customerGST ? CustomerDetail.customerGST : '',
                date: setDate,
                credit: parseFloat(amt),
                debit: 0,
                payable: 0,
                receivable: -1 * parseFloat(amt),
                isCustomer: CustomerDetail.isCustomer ? 1 : 0

            };
            data.cash = data.credit


        } else if (type === "debit") {
            data = {
                customerName: CustomerDetail.customerName,
                customerDetails: CustomerDetail.customerDetails ? CustomerDetail.customerDetails : "",
                customerContact: CustomerDetail.customerContact ? CustomerDetail.customerContact : "",
                customerGST: CustomerDetail.customerGST ? CustomerDetail.customerGST : '',
                date: setDate,
                credit: 0,
                debit: parseFloat(amt),
                receivable: CustomerDetail.isCustomer ? parseFloat(amt) : 0,
                payable: CustomerDetail.isCustomer ? 0 : (-1 * parseFloat(amt)),
                isCustomer: CustomerDetail.isCustomer ? 1 : 0
            };
            data.cash = -data.debit
        }
        if (CustomerDetail.customerName === 'Cash') {
            data.receivable = 0
            data.payable = 0
        }
        // console.log(data);

        db.ledger.put(data).then(res => {
            console.log("Ledger Generated", res);
            toastController.create({
                color: 'success',
                duration: 2000,
                message: `Ledger data added successfully`,
                showCloseButton: true
            }).then(toast => {
                toast.present();
            });
        });
        db.ledger
            .where("customerName")
            .equals(CustomerDetail.customerName)
            .toArray()
            .then(res => {
                setLedger(res.map((item) => {
                    item.date = new Date(item.date)
                    return item
                }));
            });
    };

    // printing data and ledger

    const printLedger = () => {
        let ledger = {
            date: moment(Date()).format("DD/MM/YY"),
            companyName: Company.name,
            companyAddress: Company.address,
            companyContact: Company.contact,
            customerName: CustomerDetail.customerName,
            customerDetails: CustomerDetail.customerDetails ? CustomerDetail.customerDetails : "",
            customerContact: CustomerDetail.customerContact ? CustomerDetail.customerContact : "",
            customerGST: CustomerDetail.customerGST ? CustomerDetail.customerGST : '',
            gst: Company.gst,
            ledger: Ledger,
            balance: balance,
            credit: credit,
            debit: debit
        };

        // console.log(ledger);

        let print = document.getElementById("print").contentWindow;
        print.document.write(ledgerPattern(ledger));
        print.document.close();
        print.focus();
        print.print();
    };

    const printVoucher = (voucherDate, amt) => {
        let voucher = {
            companyName: Company.name,
            companyAddress: Company.address,
            companyContact: Company.contact,
            customerName: CustomerDetail.customerName,
            customerDetails: CustomerDetail.customerDetails ? CustomerDetail.customerDetails : "",
            customerContact: CustomerDetail.customerContact ? CustomerDetail.customerContact : "",
            customerGST: CustomerDetail.customerGST ? CustomerDetail.customerGST : '',
            gst: Company.gst,
            billDate: voucherDate,
            amtPaid: amt
        }

        console.log(voucher);
        let print = document.getElementById("print").contentWindow;
        print.document.write(PaymentReceiptPattern(voucher));
        print.document.close();
        print.focus();
        print.print();
    }

    return {

        date, setDate, amt, setAmt,
        alert, setAlert, editable, seteditable,
        CustomerDetail, setCustomerDetail,
        Company, Ledger, setLedger,
        debit , credit , balance,
        addToLedger,
        printLedger,
        printVoucher,
        deleteCustomer,
        removeFromLedger,

    }
}